import PhoneMask from '../phone-mask';
import FormGoogleAnalytics from "../form-google-analytics";
import { AbideFunctionMapper } from '../abide-function-mapper';

function JoinTheMovementForm(config) {

    let obj = {
        config: config,
        formContainer: $(config.formContainer),
        form: $(config.form),
        stateDropdown: $(config.stateDropdown),
        communityDropdown: $(config.communityDropdown),
        dateDropdown: $(config.dateDropdown),
        guestDropdown: $(config.guestDropdown),
        dropdownDataset: $(config.dropdownDataset),
        dateType: $(config.dateType),
        submitButton: $(config.submitButton),
        confirmationContainer: $(config.confirmationContainer)
    };

    return init();

    function init() {
        obj.form.on('submit', (event) => {
            event.preventDefault();
        });
        PhoneMask().AddPhoneMaskByElement(obj.form.find('input[type="tel"]'));
        initializeAbideValidation();
        initFormDropdowns();
    }

    function initializeAbideValidation() {
        if (!obj.abideFunctionMapper) {
            obj.abideFunctionMapper = AbideFunctionMapper();
        }
        obj.abideFunctionMapper.map("shm", "forms", "jointhemovement", onSubmitClick);
        
        $(document).off("formvalid.zf.abide").on("formvalid.zf.abide", function (ev, frm) {
            if (frm.attr('id') === obj.form.attr('id')) {
                window.showPreLoader();
                // Call the submit function
                // Code in the submit is asynchronous, so need to pass a function to call after the submission is done
                obj.abideFunctionMapper.call("shm", "forms", "jointhemovement", function () { window.hidePreLoader(); });
            } else {
                window.hidePreLoader();
            }
        });
    }

    function initFormDropdowns() {
        // Populate State dropdown
        removeElements(obj.stateDropdown);
        let objDS = $.parseJSON(obj.dropdownDataset.val());
        objDS = objDS.sort(sortByProperty('State'));
        let select2Options = [];
        for (let i = 0; i < objDS.length; i++) {
            if ($.inArray(objDS[i].State, select2Options) === -1) {
                //not in array so we need to add it
                select2Options.push(objDS[i].State);
            }
        }
        obj.stateDropdown.select2({ data: select2Options });

        // community dropdown
        obj.communityDropdown.prop("disabled", true);
        removeElements(obj.communityDropdown);

        // date dropdown
        obj.dateDropdown.prop("disabled", true);
        removeElements(obj.dateDropdown);

        // dropdown foundation init
        initCustomDropdowns(obj.stateDropdown);
        initCustomDropdowns(obj.communityDropdown);
        initCustomDropdowns(obj.dateDropdown);
        initCustomDropdowns(obj.guestDropdown);

        obj.stateDropdown.on("change", function () {
            statesIndexChange(this);
        });

        obj.communityDropdown.on("change", function () {
            communitiesIndexChange(this);
        });

        obj.dateDropdown.on("change", function () {
            dateIndexChanged(this);
        });

        obj.guestDropdown.on("change", function () {
            guestIndexChanged(this);
        });
    }

    function onSubmitClick() {
        submitData().then((response) => {
            console.log("Response Succeeded: " + response);
            toggleCompletion(true);
            window.hidePreLoader();
        }).catch((error) => {
            console.error(error);
        });
    }

    //-------------------------------------------------------------------------------------------------
    // Constructs the postData object from the FormData
    //-------------------------------------------------------------------------------------------------
    function getPostData() {
        let formPostData = getFormData();
        formPostData.GAData = FormGoogleAnalytics().getGAData();
        return formPostData;
    }

    //-------------------------------------------------------------------------------------------------
    // Gets all of the properites from the input fields under the form element
    //-------------------------------------------------------------------------------------------------
    function getFormData() {
        let fields = {};
        obj.form.find(":input").each(function () {
            // The selector will match buttons; if you want to filter
            // them out

            // Prevent XSS. Escape input
            let escaped = $('<div />').text($(this).val()).html();
            fields[this.name] = escaped;
        });
        return fields;
    }

    function submitData() {
        // In CMS preview, just show the completion screen, don't submit
        if (obj.config.isPreviewEnabled) {
            toggleCompletion(true);
            return;
        }

        return new Promise(function (resolve, reject) {
            try {
                if (window.patternLibrary) // set in the sevice request page but only in the pattern library
                {
                    setTimeout(function () {
                        if (resolve) resolve();
                    }, 500);
                    return;
                }

                // Get Anti-CSRF token
                let csrfToken = $("[name='__RequestVerificationToken']").val();
                let postData = getPostData();

                $.ajax({
                    type: "POST",
                    url: '/forms/jointhemovement',
                    data: postData,
                    cache: false,
                    beforeSend: function (request) {
                        if (csrfToken) {
                            request.setRequestHeader("__RequestVerificationToken", csrfToken);
                        }
                    },
                    success: function (response) {
                        if ((response.Status && response.Status == "200")
                            || response.IsSuccess) {

                            // Send data to GTM
                            var formName = obj.form.data("form-name");
                            if (formName != null && dataLayer) {
                                dataLayer.push({ 'event': 'formComplete', 'formType': formName });
                            }

                            if (resolve) resolve(response);
                        }
                        else {
                            if (reject) reject(response);
                        }
                    },
                    error: function (request, textStatus, errorThrown) {
                        if (reject) reject("AJAX error: " + request.statusText);
                    }
                });
            }
            catch (err) {
                if (reject) reject("Error occurrect submittion form:" + err);
            }
        });
    }

    function toggleCompletion(bShow) {
        if (bShow) {
            // Show completion / hide form
            obj.formContainer.addClass('hide');
            obj.confirmationContainer.removeClass('hide');
        }
        else {
            // Hide completion / show form
            obj.formContainer.removeClass('hide');
            obj.confirmationContainer.addClass('hide');
        }
    }

    function statesIndexChange(ddlStates) {
        let selectedText = ddlStates.options[ddlStates.selectedIndex].innerText;

        obj.communityDropdown.attr("disabled", true);
        removeElements(obj.communityDropdown);

        obj.dateDropdown.prop("disabled", true);
        removeElements(obj.dateDropdown);

        obj.guestDropdown.prop("disabled", true);
        removeElements(obj.guestDropdown);


        if (selectedText === "Select a State") {
            // reset the submit button
            obj.submitButton.prop("disabled", true);
        }
        else {
            let objDS = "";
            if (obj.dropdownDataset != null) {
                objDS = $.parseJSON(obj.dropdownDataset.val());
                objDS = objDS.sort(sortByProperty('Community'));
            }
            for (let i = 0; i < objDS.length; i++) {
                if (objDS[i].State == selectedText) {
                    let isExist = elementExist(obj.communityDropdown, objDS[i].Community);
                    if (isExist === false)
                        obj.communityDropdown.append($('<option></option>').attr('value', objDS[i].Community).text(objDS[i].Community));
                }
            }

            obj.communityDropdown.prop("disabled", false);
        }

        initCustomDropdowns(obj.communityDropdown);
        initCustomDropdowns(obj.dateDropdown);
        initCustomDropdowns(obj.guestDropdown);
    }

    function communitiesIndexChange(ddlCommunities) {
        let selectedText = ddlCommunities.options[ddlCommunities.selectedIndex].innerText;

        obj.dateDropdown.attr("disabled", true);
        removeElements(obj.dateDropdown);

        obj.guestDropdown.prop("disabled", true);
        removeElements(obj.guestDropdown);

        if (selectedText === "Select a Community") {
            // reset the submit button
            obj.submitButton.prop("disabled", true);
        } 
        else {
            let dateType = obj.dateType.val();
            let objDS = $.parseJSON(obj.dropdownDataset.val());
            objDS = objDS.sort(sortByDateProperty('EventDate'));
            for (let i = 0; i < objDS.length; i++) {
                if (objDS[i].DateType === dateType) {
                    if (objDS[i].Community == selectedText) {
                        if (objDS[i].EventDate !== 'auto' && (dateType === 'EventDates' || dateType === "AllEventMonths")) {
                            let isExist = elementExist(obj.dateDropdown, objDS[i].DateFormatted);
                            if (isExist === false)
                                obj.dateDropdown.append($('<option></option>').attr('value', objDS[i].DateFormatted).text(objDS[i].DateFormatted));
                        } else if (dateType === 'AllMonths') {
                            let today = new Date();
                            const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                            let todayDay = today.getMonth();
                            let todayYear = today.getFullYear();
                            let yearIncreased = false;
                            let result = "";
                            for (let i = 0; i < 12; i++) {
                                result = monthNames[(i + todayDay) % 12] + " " + todayYear;
                                obj.dateDropdown.append($('<option></option>').attr('value', result).text(result));

                                if (i + todayDay >= 11 && yearIncreased === false) {
                                    todayYear++;
                                    yearIncreased = true;
                                }
                            }
                            break;
                        }
                    }
                }
            }
            obj.dateDropdown.prop("disabled", false);
        }
        initCustomDropdowns(obj.dateDropdown);
        initCustomDropdowns(obj.guestDropdown);
    }

    function dateIndexChanged(ddlEvent) {
        let selectedText = ddlEvent.options[ddlEvent.selectedIndex].innerText;

        obj.guestDropdown.attr("disabled", true);
        removeElements(obj.guestDropdown);

        if (selectedText === "Select a Date") {
            initCustomDropdowns(obj.guestDropdown);
            obj.submitButton.prop("disabled", true);
        } else {
            obj.guestDropdown.append($('<option></option>').attr('value', 'yes').text('Yes'));
            obj.guestDropdown.append($('<option></option>').attr('value', 'no').text('No'));
            obj.guestDropdown.append($('<option></option>').attr('value', 'unsure').text('I don\'t know'));
            obj.guestDropdown.prop("disabled", false);
            initCustomDropdowns(obj.guestDropdown);
        }
    }

    function guestIndexChanged(ddlGuest) {
        if (ddlGuest.value !== "") {
            obj.submitButton.removeAttr("disabled");
        } else {
            obj.submitButton.attr("disabled", true);
        }
    }

    function removeElements(element) {
        $("#" + element.attr('id')).find('option').not(':first').remove();
    }

    function elementExist(element, valuetocheck) {
        var IsExists = false;
        $('#' + element.attr('id') + ' option').each(function () {
            if (this.value == valuetocheck)
                IsExists = true;
        });

        return IsExists;
    }

    function sortByDateProperty(property) {
        return function (x, y) {
            let t1 = new Date(x[property]).getTime();
            let t2 = new Date(y[property]).getTime();

            if (isNaN(t1) || isNaN(t2))
                return 0;

            return ((t1 === t2) ? 0 : ((t1 > t2) ? 1 : -1));
        };
    };

    function sortByProperty(property) {
        return function (x, y) {
            return ((x[property] === y[property]) ? 0 : ((x[property] > y[property]) ? 1 : -1));
        };
    };
}
export default JoinTheMovementForm;